import { DocumentNode, gql } from '@apollo/client'

export const CREATE_BLACKLIST: DocumentNode = gql`
    mutation CreateBlacklist($email: String!) {
        createBlacklist(email: $email)
    }
`

export const GET_BLACKLIST: DocumentNode = gql`
    query GetBlacklist {
        getBlacklist
    }
`

export const UPDATE_BLACKLIST: DocumentNode = gql`
    mutation UpdateBlacklist($email_search: String!, $email_replacement: String!) {
        updateBlacklist(email_search: $email_search, email_replacement: $email_replacement)
    }
`

export const DELETE_BLACKLIST: DocumentNode = gql`
    mutation DeleteBlacklist($email: String!) {
        deleteBlacklist(email: $email)
    }
`
